import { CampaignIndustry, ProjectFormData } from '../types';

export const CAMPAIGN_INDUSTRY_LABELS: Record<CampaignIndustry, string> = {
  real_estate: 'العقارات',
  ecommerce: 'التجارة الإلكترونية',
  professional_services: 'الخدمات المهنية',
  education: 'التعليم والتدريب',
  healthcare: 'الصحة والعيادات',
  restaurants: 'المطاعم والكافيهات',
  automotive: 'السيارات',
  tourism: 'السياحة والفنادق',
  fitness: 'اللياقة البدنية والرياضة',
  mobile_apps: 'تطبيقات الهاتف والخدمات الرقمية',
};

export function getCampaignIndustry(projectInfo: Partial<ProjectFormData>): CampaignIndustry {
  return projectInfo.industry || 'real_estate';
}

export function isRealEstateCampaign(projectInfo: Partial<ProjectFormData>): boolean {
  return getCampaignIndustry(projectInfo) === 'real_estate';
}
